import { handleTextOverflow } from '@repo/ui/components/utilities';
import { themeStyle } from '@repo/ui/theming';
import styled, { css, keyframes } from 'styled-components';

export const SuggestionsWrapper = styled.div`
  min-height: ${({ theme }) => theme.height};
  overflow: hidden;
  position: relative;
  width: ${({ theme }) => theme.width};
`;

export const Suggestion = styled.div<{ isActive: boolean; theme: any }>`
  ${handleTextOverflow}
  color:${({ isActive, theme }) =>
    isActive ? theme.colorSuggestionActive : theme.colorSuggestion};
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.activeSuggestionBackground : 'unset'};

  &:not(:last-of-type) {
    border-bottom: ${({ theme }) => theme.separator};
  }

  width: 100%;
  height: ${({ theme }) => theme.height};
`;

export const SuggestionContent = styled.div`
  padding: 10px 14px;
  text-align: left;
  cursor: pointer;
`;

const moveBackgroundToRight = keyframes`
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
`;

const animationRule = css`
  ${moveBackgroundToRight} 1s linear infinite;
`;

export const Loader = styled.div`
  animation: ${animationRule};
  background: linear-gradient(
    90deg,
    ${themeStyle.varInkBase} 45%,
    ${themeStyle.varInkMedium} 45% 55%,
    ${themeStyle.varInkBase} 55%
  );
  background-size: 220%;
  height: 5px;
  position: absolute;
  top: 0;
  width: 100%;
`;
